export const fileAttachmentType: string = 'FileAttachment:#Exchange';
export const itemIdAttachmentType: string = 'ItemIdAttachment:#Exchange';
export const referenceAttachmentType: string = 'ReferenceAttachment:#Exchange';
export const OneKBInBytes: number = 1024;
export const OneMBInBytes: number = 1024 * 1024;
export const SpecialCharactersAreNotSupportedError: string = 'Not support special characters';
